import React from 'react';

import Spacer from '../spacer/Spacer';
import { Icon } from '@/components/memo';

import './ModalHeader.css';

interface ModalHeaderProps {
  title?: string | React.ReactNode;
  leftIcon?: string | null;
  onClickLeftIcon?: () => void;
  rightIcon?: string | null;
  onClickRightIcon?: () => void;
  fixed?: boolean;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  leftIcon,
  onClickLeftIcon,
  rightIcon,
  onClickRightIcon,
  fixed
}) => {
  return (
    <>
      <div className={`modal-header ${fixed ? 'modal-header--fixed' : ''}`}>
        {leftIcon && (
          <Icon
            icon={leftIcon}
            onClick={onClickLeftIcon}
            className="modal-header__icon"
          />
        )}
        {title && <h1 className="modal-header__title">{title}</h1>}
        {rightIcon && (
          <Icon
            icon={rightIcon}
            onClick={onClickRightIcon}
            className="modal-header__icon"
          />
        )}
      </div>
      {fixed && <Spacer top={62} />}
    </>
  );
};

export default ModalHeader;
